import React from 'react'
import clsx from 'clsx'
import { VolumeHigh, Document } from 'iconsax-react'
import { useTheme } from '@mui/material'

import OverflowText from '../../../../../atoms/OverflowText'
import CloseButton from '../CloseButton'

import useStyles from './styles'

const Other = ({ file, onDelete }) => {
  const theme = useTheme()

  const [hovering, setHovering] = React.useState(false)

  const Icon = React.useMemo(() => {
    const type = file.type ?? ''
    if (type.startsWith('audio')) {
      return props => (
        <VolumeHigh
          size={theme.size.xl}
          variant='Bold'
          color='white'
          {...props}
        />
      )
    } else {
      return props => (
        <Document
          size={theme.size.xl}
          variant='Bold'
          color='white'
          {...props}
        />
      )
    }
  }, [file.type, theme])

  const type = React.useMemo(() => {
    const type = file.type ?? ''

    if (type.includes('/')) {
      const types = type.split('/')
      return (types[1] ?? '').toLocaleUpperCase()
    }

    return file.type.toLocaleUpperCase()
  }, [file.type])

  const classes = useStyles()

  return (
    <div
      onMouseEnter={() => setHovering(true)}
      onMouseLeave={() => setHovering(false)}
      className={classes.root}
    >
      <div className={classes.content}>
        <Icon className={classes.icon} />

        <div className={classes.info}>
          <OverflowText className={classes.title}>{file.name}</OverflowText>

          <OverflowText className={clsx(classes.title, classes.type)}>
            {type}
          </OverflowText>
        </div>

        {hovering && <CloseButton onDelete={onDelete} />}
      </div>
    </div>
  )
}

export default Other
